import { TimelinePassThroughOptions, TimelineProps } from 'primereact/timeline';
import { classNames } from 'primereact/utils';

export const PTTimeline: TimelinePassThroughOptions = {
  root: ({ props }: { props: TimelineProps }) => ({
    className: classNames('flex grow', {
      'flex-col': props.layout === 'vertical',
      'flex-row flex-1': props.layout === 'horizontal',
    }),
  }),
  event: ({ props, context }: { props: TimelineProps; context: any }) => ({
    className: classNames(
      'flex relative min-h-[45px] hover:bg-blue-extra-light p-1 rounded-lg mr-2 cursor-pointer transition-all',
      {
        'flex-row-reverse':
          props.align === 'right' ||
          (props.layout === 'vertical' &&
            props.align === 'alternate' &&
            context.index % 2 === 1),
        'flex-col flex-1': props.layout === 'horizontal',
        'flex-col-reverse ':
          props.align === 'bottom' ||
          (props.layout === 'horizontal' &&
            props.align === 'alternate' &&
            context.index % 2 === 1),
      },
    ),
  }),
  opposite: () => ({
    className: classNames('flex-0'),
  }),
  separator: ({ props }: { props: TimelineProps }) => ({
    className: classNames('flex items-center flex-initial min-w-[20px]', {
      'flex-col': props.layout === 'vertical',
      'flex-row': props.layout === 'horizontal',
    }),
  }),
  marker: {
    className:
      'flex self-baseline w-4 h-4 rounded-full border-2 border-blue-500 bg-white',
  },
  connector: ({ props }: { props: TimelineProps }) => ({
    className: classNames('grow bg-gray-dark my-2', {
      'w-[2px]': props.layout === 'vertical',
      'w-full h-[2px]': props.layout === 'horizontal',
    }),
  }),
  content: ({ props, context }: { props: TimelineProps; context: any }) => ({
    className: classNames(
      'flex-1',
      {
        'px-4': props.layout === 'vertical',
        'py-4': props.layout === 'horizontal',
      },
      {
        'text-left':
          props.align === 'left' ||
          (props.layout === 'vertical' &&
            props.align === 'alternate' &&
            context.index % 2 === 0),
        'text-right':
          props.align === 'right' ||
          (props.layout === 'vertical' &&
            props.align === 'alternate' &&
            context.index % 2 === 1),
      },
      {
        'min-h-0':
          props.layout === 'vertical' && context.index === context.count,
        'grow-0':
          props.layout === 'horizontal' && context.index === context.count,
      },
    ),
  }),
};
